const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-4" data-testid="brand-logo">
    <span className="relative inline-block leading-none">
      <span
        className={`font-serif text-[2.75rem] font-light ${dark ? "text-forest" : "text-ivory"}`}
        aria-hidden="true"
      >
        R
      </span>
      <span className="absolute -top-1 left-[38%] h-[6px] w-[6px] rounded-full bg-accent animate-dot-pulse" />
    </span>
    <span className="flex flex-col leading-tight">
      <span
        className={`font-sans text-sm font-medium tracking-[0.32em] ${dark ? "text-forest" : "text-ivory"}`}
      >
        ROYAL ESSENCE
      </span>
      <span className="mt-1 font-sans text-[9px] tracking-[0.3em] text-gold">
        MASSAGE BEYOND MUSCLES
      </span>
    </span>
  </span>
);

export default Logo;
